// @flow

import React from 'react';
import type { Node } from 'react';
import FieldWrapper from '../labeledFieldWrapper';
import LabeledField from '../labeledField';

type Props = {
  label: string,
  children: Node,
};

export default ({
  label,
  children,
}: Props) => (
  <LabeledField label={label}>
    <FieldWrapper>{children}</FieldWrapper>
  </LabeledField>
);
